import { post } from '@alltrails/core/utils/post';
import type CompleteCheckoutSessionBody from '../types/CompleteCheckoutSessionBody';
import type ProResponse from '../types/ProResponse';

export default function completeCheckoutSessionSubscription({
  checkoutSessionId,
  threeDSecureActionResultTokenId
}: {
  checkoutSessionId: string;
  threeDSecureActionResultTokenId: string;
}) {
  return post<ProResponse>(`/api/alltrails/purchases/checkout_sessions/${checkoutSessionId}/subscriptions`, {
    three_d_secure_action_result_token_id: threeDSecureActionResultTokenId
  } satisfies CompleteCheckoutSessionBody);
}
